<template>
    <div>
        <div v-if="cart" class="shopping-cart-icon-wrapper text-right dropdown" v-b-modal.modal-shopping-cart data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
            <i class="fa fa-shopping-cart shopping-cart-icon pt-1"></i>
            <div v-if="cart && cart.count >= 1" class="cart-badge ">{{cart.count}}</div>

            <div class="dropdown-menu dropdown-menu-right"
                 onclick="event.stopPropagation()"
                 aria-labelledby="dropdown-customer"
                 style="width: 375px; overflow-y: auto; max-height: calc(100vh - 82px);"
                 v-if="cart && cart.count >= 1"
            >
                <div class="pt-3 pb-4 clearfix">
                    <h4 class="blue-text mt-0 mb-3 h2-title px-4">Winkelwagen</h4>

                    <div v-html="itemsHtml" class="px-4 cart-items-container"></div>

                    <div class="px-4">
                        <shopping-cart-totals-component class="mt-3"></shopping-cart-totals-component>

                        <a href="/checkout"
                           class="btn btn-buy buy float-right mt-4 ml-4 js-goto-checkout"
                        >Bestellen</a>

                        <a href="/winkelwagen"
                           class="buy float-right mt-4 ml-4 btn btn-link"
                        >Wijzig winkelwagen</a>
                    </div>
                </div>
            </div>
            <div v-else class="dropdown-menu dropdown-menu-right empty-cart"
                 onclick="event.stopPropagation()"
                 aria-labelledby="dropdown-customer"
                 style="width: 375px; overflow-y: auto; max-height: calc(100vh - 82px);"
            >
                <div class="pt-3 pb-4 clearfix">
                    <h4 class="blue-text mt-0 mb-3 h2-title px-4">Winkelwagen</h4>

                    <div v-html="itemsHtml" class="px-4 cart-items-container"></div>

                    <div class="px-4">
                        U heeft geen producten in uw winkelwagen
                    </div>
                </div>

            </div>
        </div>
        <div v-else class="shopping-cart-icon-wrapper text-right dropdown" v-b-modal.modal-shopping-cart data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <div class="dropdown-menu dropdown-menu-right empty-cart"
                 onclick="event.stopPropagation()"
                 aria-labelledby="dropdown-customer"
                 style="width: 375px; overflow-y: auto; max-height: calc(100vh - 82px);"
            >
                <div class="pt-3 pb-4 clearfix">
                    <h4 class="blue-text mt-0 mb-3 h2-title px-4">Winkelwagen</h4>

                    <div v-html="itemsHtml" class="px-4 cart-items-container"></div>

                    <div class="px-4">
                        U heeft geen producten in uw winkelwagen
                    </div>
                </div>

            </div>
        </div>

        <div v-if="!cart" class="shopping-cart-icon-wrapper text-right dropdown">
            <i class="fa fa-shopping-cart shopping-cart-icon pt-1"></i>
        </div>
    </div>
</template>

<script>
    export default {

        /*
         * The component's data.
         */
        data() {
            return {
                cart: null,
                itemsHtml: null,
                shoppingCartService:  window.ShoppingCartService
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {

                bus.$on('shopping-cart-items-html-loaded', function(itemsHtml) {

                    this.itemsHtml = itemsHtml;

                }.bind(this));

                bus.$on('shopping-cart-changed', function(cart) {
                    this.cart = cart;

                    if (cart.rowId !== 'undefined' && cart.rowId) {
                        this.$cookie.set(this.shoppingCartService.getHashKey(), cart.rowId);
                    }
                }.bind(this));

                let hash = this.$cookie.get(this.shoppingCartService.getHashKey());

                if(hash) {
                    this.shoppingCartService.getItemsHtml();
                    this.shoppingCartService.getByHash(hash);
                }
            },

        }
    }
</script>
